import React, { Component } from 'react';
import './style.scss';
import SelectField from '../../../../../helpers/Fields/SelectField';
import { connect } from 'react-redux'
import { getMessage } from '../../../../actions';
import Spiner from '../../../../../helpers/Spiner/Spiner';
import PropTypes from 'prop-types'
import moment from 'moment'

class QuestionsStudent extends Component {
  static contextTypes = {formatMessage: PropTypes.any}
  state = {
    messages: [],
    loaded: true
  }

  async componentDidMount(){
    this.setState({
      messages: [],
      loaded: false
    })
    const data = await getMessage(this.props.session_id);
    this.setState({
      messages: data,
      loaded: true
    })
  }

  async UNSAFE_componentWillReceiveProps(nextProps){
    if(nextProps.session_id != this.props.session_id){
      this.setState({
        messages: [],
        loaded: false
      })
      const data = await getMessage(nextProps.session_id);
      this.setState({
        messages: data,
        loaded: true
      })
    }
  }

  onChange = async (id) => {
   
    this.setState({
      messages: [],
      loaded: false
    })
    const data = await getMessage(id);
    this.setState({
      messages: data,
      loaded: true
    })
  }

  render() {
    const {formatMessage} = this.context;

    const {sessions} = this.props;
    const {messages, loaded} = this.state;
    return (
      <div className="QuestionsStudent">
        <div className="question-student">
          {!loaded && <Spiner />}
            {messages.map(item => <div key={item.id} className="item-message">
              <div className="slide-index">#{(item.slide_index *1)+1}</div>
              {item.message}
            </div>)}
        </div>
      </div>
    );
  }
}


const mapStateToProps = (state, ownProps) => ({
  sessions: state.presentation.sessions
})

const mapDispatchToProps = {
  
}

export default connect(mapStateToProps, mapDispatchToProps)(QuestionsStudent)



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Presentation/components/Slide/components/QuestionsStudent/index.jsx